export default "__VITE_ASSET__c90ba94b__"